
<div class="alerts-container">
<h1 class="app-heading app-heading-1">{{'alerts'|translation}}</h1>
<app-table
emptyText="No Alerts Found"
[hasBorders]="false"
[hasAlternatingRows]="true"
[isLoading]="isLoading"
[rows]="alerts"
[columns]="columns"
[showPaginator]="true"
[itemCount]="itemCount"
[perPage]="perPage"
[pageNumber]="pageNumber"
[sortBy]="sortBy"
[filterInput]="filterInput"
[sortAsc]="sortAsc"
[undefinedText]="''"
[canSearch]="true"
(initSearch)="initSearch($event)"
(setPageCount)="setPageCount($event)"
(sortChange)="sortChange($event)"
(activePageChange)="activePageChange($event)"
(columnRowClicked)="linkClicked($event)"
>
<div table-search>
    <app-input-dropdown
      class="input-dropdown"
      placeholder="Select Status"
      [control]="statusControl"
      [options]="statusOptions"
    ></app-input-dropdown>
  </div>
  </app-table>
</div>
